/**
 * @generated SignedSource<<cd1ba3099e75104640098810f83c64a2>>
 * @relayHash c879c122491285841c431ba88e98867e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a727cea1b43d9f2cef75fa50de2bcbca0808bca56bc73cdc09d7a78108aedab

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CommitDetailsPopupViewQuery } from './CommitDetailsPopupViewQuery.graphql';

const node: PreloadableConcreteRequest<CommitDetailsPopupViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6a727cea1b43d9f2cef75fa50de2bcbca0808bca56bc73cdc09d7a78108aedab",
    "metadata": {},
    "name": "CommitDetailsPopupViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
